import { useEffect, useState } from "react";
import { Box, IconButton, Table, TableBody, TableCell, TableHead, TableRow, TextField, Select, MenuItem, FormControl, InputLabel } from "@mui/material";

import Button from '@mui/material/Button';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PaidIcon from '@mui/icons-material/Paid';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';

import Obj2StrArr from './Obj2StrArr.js'
import dateFix from "./DateFix.js";
import dateString from "./DateString.js";

import Receipt from "./Receipt.js";
import safeAddress from "./SafeAddress.js";

function MemberMovements(props) {
    const { User, MemberData, FamilyGroupData, MovementsData, MemberId, Means, lastReceitpNumber, cancelDebit, DbUpload, offlineMovementsUpdate, EscKeyStroke, readyToClose, minimal = false, } = props;
    const [moves, setMoves] = useState([]);
    const [showHistory, setShowHistory] = useState(false);
    const [specialDebit, setSpecialDebit] = useState({ disabled: false, show: false, count: 1, concept: '', amount: '' });
    const [newPayment, setNewPayment] = useState({ disabled: false, show: false, total: 0, discount: 0, concept: '', amount: '' });
    const [checkedMoves, setCheckedMoves] = useState([]);
    const [removeDebitList, setRemoveDebitList] = useState([]);
    const [receiptRendering, setReceiptRendering] = useState({ render: false });

    useEffect(() => {
        readyToClose(EscKeyStroke && (!specialDebit.show && !newPayment.show && !showHistory))
        if (EscKeyStroke) {
            setSpecialDebit(prev => ({ ...prev, show: false }));
            setNewPayment(prev => ({ ...prev, show: false }));
            setShowHistory(false);
        }
    }, [EscKeyStroke, specialDebit, newPayment, showHistory])

    useEffect(() => {
        let movements = [];
        for (let date in MovementsData)
            for (let ts in MovementsData[date]) {
                let move = { ...MovementsData[date][ts], key: ts };
                move.status = (move.Estado || move.tipo || '').toLowerCase();
                let sx = { fontSize: '18px', marginBottom: '-4px' };
                if (newPayment.show && ['vencido', 'debito'].includes(move.status)) sx.cursor = 'pointer';
                move.checkDisabled = checkedMoves.length && ((moves.find(m => m.key === checkedMoves[0]) || {}).socio || '') !== move.socio;
                if (move.checkDisabled) sx.opacity = .5;
                move.icon = {
                    pagado: <CheckCircleIcon color="success" sx={sx} />,
                    pago: <PaidIcon color="success" sx={{ ...sx, cursor: 'pointer' }} onClick={() => setReceiptRendering({ ...move, render: true })} onDoubleClick={() => !minimal && cancelPayment(move.key)} />,
                    vencido: <RadioButtonUncheckedIcon color="error" sx={sx} onClick={() => !move.checkDisabled && !minimal && newPayment.show && newPaymentSet({ ts: move.key })} onDoubleClick={() => !minimal && !newPayment.show && setRemoveDebitList(prev => [...prev, move.key])} />,
                    debito: <RadioButtonUncheckedIcon color="success" sx={sx} onClick={() => !move.checkDisabled && !minimal && newPayment.show && newPaymentSet({ ts: move.key })} onDoubleClick={() => !minimal && !newPayment.show && setRemoveDebitList(prev => [...prev, move.key])} />,
                    vencidoCh: <CheckCircleOutlineIcon color="error" sx={sx} onClick={() => !minimal && newPaymentSet({ ts: move.key })} />,
                    debitoCh: <CheckCircleOutlineIcon color="success" sx={sx} onClick={() => !minimal && newPaymentSet({ ts: move.key })} />,
                    vencidoRm: <RadioButtonCheckedIcon color="error" sx={sx} onDoubleClick={() => !minimal && !newPayment.show && setRemoveDebitList(prev => prev.filter(m => m !== move.key))} />,
                    debitoRm: <RadioButtonCheckedIcon color="success" sx={sx} onDoubleClick={() => !minimal && !newPayment.show && setRemoveDebitList(prev => prev.filter(m => m !== move.key))} />,
                    anulado: <HighlightOffIcon color="black" sx={sx} />,
                    'pago-anulado': <MoneyOffIcon color="black" sx={{ ...sx, cursor: 'pointer' }} onClick={() => setReceiptRendering({ ...move, render: true })} />,
                }[move.status + (newPayment.show && checkedMoves.includes(move.key) ? 'Ch' : '') + (!newPayment.show && removeDebitList.includes(move.key) ? 'Rm' : '')] || <>{console.error(`Icono no identificado: ${move.status}`)}</>;
                move.iconTitle = {
                    'pagado': 'Pagado',
                    'pago': 'Pago Registrado',
                    'vencido': 'Pendiente de Pago',
                    'debito': 'Pendiente de Pago',
                    'anulado': 'Anulado',
                    'pago-anulado': 'Pago Anulado',
                }[move.status];
                move.dueDate = new Date(move.Vencimiento);
                movements.push(move)
            }
        setMoves(movements.sort((a, b) => a.dueDate - b.dueDate));
    }, [MovementsData, checkedMoves, newPayment, removeDebitList])

    const dataTable = [
        { header: '', field: 'icon', sx: {}, title: 'iconTitle', valueGetter: (v) => v },
        { header: 'Concepto', field: 'Concepto', sx: {}, title: 'DetEstado', valueGetter: (v) => v },
        { header: 'Monto', field: 'Monto', sx: { textAlign: 'end', '&::before': { content: '"$ "' } }, valueGetter: (v) => v },
        { header: 'Medio', field: 'Medio', sx: { fontSize: '10px' }, valueGetter: (v) => v },
        { header: 'Vencimiento', field: 'Vencimiento', sx: { textAlign: 'center', fontSize: '10px' }, valueGetter: (v) => dateFix(v, 1) },
        { header: 'Fecha', field: 'Fecha', sx: { textAlign: 'center', fontSize: '10px' }, valueGetter: (v) => dateFix(v) },
    ]

    const moveRow = (move) => (
        <TableRow
            key={`${move.key}-tablerow`}
            sx={(move.Estado || '').toLowerCase().includes('anulado') ? {
                position: "relative",
                '&:not(:hover)::after': {
                    content: '""',
                    position: 'absolute',
                    top: "50%",
                    height: 0,
                    left: '2em',
                    right: '.25em',
                    borderTop: 'solid 1px #0008',
                }
            } : {}}
        >
            {dataTable.map(field =>
                <TableCell
                    key={`${move.key}-${field.header}`}
                    sx={field.sx}
                    title={field.title ? move[field.title] : null}
                >
                    {field.valueGetter(move[field.field])}
                </TableCell>
            )}
        </TableRow>
    )
    const specialDebitSet = (p) => {
        let o = { ...specialDebit, ...p };
        o.disabled = !o.concept || !o.amount || !o.count;
        setSpecialDebit(o)
    }

    const specialDebitUpload = () => {
        let data = {
            Concepto: specialDebit.concept,
            Fecha: dateString().substring(0, 10),
            Medio: 'Debito Especial',
            Monto: Number(specialDebit.amount) || 0,
            Timestamp: new Date(),
            UserId: User.uid,
            Usuario: User.nombre,
            montoOrig: specialDebit.amount,
            socio: MemberId,
            tipo: 'debito',
        };
        if (data.Monto >= 0) {
            let dueMonth = new Date().getMonth() + 2,
                upTo = Number(dueMonth) + Number(specialDebit.count),
                uploadsArray = {};
            for (dueMonth; dueMonth < upTo; dueMonth++) {
                let tmonth = dueMonth,
                    year = new Date().getFullYear();
                if (tmonth > 12) { tmonth -= 12; year += 1; }
                if (tmonth < 10) { tmonth = '0' + tmonth; }
                let debitDetail = { ...data, Vencimiento: year + '-' + tmonth + '-01' },
                    saves = true;
                for (let move of moves)
                    if (
                        move.Concepto === debitDetail.Concepto
                        && move.Vencimiento === debitDetail.Vencimiento
                    )
                        saves = false;
                if (saves)
                    Object.assign(uploadsArray, Obj2StrArr(debitDetail, `/movements/${MemberId}/${debitDetail.Vencimiento}/${dateString().replaceAll('.', ',')}-${tmonth}`) || {});
            }
            if (Object.keys(uploadsArray).length > 0) {
                DbUpload(uploadsArray).then(r => r && offlineMovementsUpdate());
                setSpecialDebit({ disabled: true, show: false, count: 1, concept: '', amount: '' });
            }
        }
    };

    const cancelPayment = (key) => {
        let payDate, payment, debits = [];
        for (let v in MovementsData) {
            if (Object.keys(MovementsData[v]).includes(key)) {
                payDate = v;
                payment = MovementsData[v][key];
                break;
            }
        }
        if (!payment) {
            window.alert(`No se ha encontrado la información del pago, contacte a soporte técnico.${"\n"}${MemberId}-${key}`)
            return;
        }
        for (let deb of payment.DetEstado.split('\n')) {
            let [concept, x] = deb.split('('),
                venc = x.split(')')[0],
                move;
            for (let v in MovementsData)
                for (let k in MovementsData[v]) {
                    if (!move
                        && safeAddress(concept.trim()) === safeAddress(MovementsData[v][k].Concepto.trim())
                        && venc.trim() === MovementsData[v][k].Vencimiento
                    ) {
                        move = { v: v, k: k, data: MovementsData[v][k] }
                        break;
                    }
                }
            if (!!move) debits.push(move);
        }

        if (window.confirm([
            `¿Confirma que desea cancelar el pago?`,
            `${payment.Fecha} - ${payment.Concepto} $${payment.Monto}`,
            '',
            `Débito${debits.length > 1 ? 's' : ''}: (${debits.length})`,
            ...debits.map(deb => `${deb.data.Vencimiento} - ${deb.data.Concepto} $${deb.data.Monto}`),
        ].join("\n"))) {
            let uploadsArray = {};
            Object.assign(uploadsArray, Obj2StrArr({
                Concepto: `${payment.Concepto}-ANULADO`,
                DetEstado: `ANULADO${"\n"}${payment.DetEstado}${"\n"}Anulado el ${dateString(1)}, ${"\n"}por ${User.nombre} (${User.uid})`,
                Estado: `${payment.Estado}-Anulado`,
            }, `/movements/${payment.socio}/${payDate}/${key}`) || {});
            for (let deb of debits) {
                Object.assign(uploadsArray, Obj2StrArr({
                    DetEstado: `Pago ANULADO - ${deb.data.DetEstado}${"\n"}Anulado el ${dateString(1)}, por ${User.nombre} (${User.uid})`,
                    Estado: null,
                    Monto: Number(deb.data.montoOrig) || '',
                }, `/movements/${deb.data.socio}/${deb.v}/${deb.k}`) || {});
            }
            DbUpload(uploadsArray).then(r => r && offlineMovementsUpdate());
        }
    }

    const newPaymentSet = (p) => {
        let pKey = Object.keys(p)[0],
            payment = { ...newPayment },
            checked = [...checkedMoves],
            concept = new Set(),
            detail = [],
            member = [];
        if (pKey !== 'ts')
            payment = { ...payment, ...p };
        switch (pKey) {
            case 'ts':
                if (checked.includes(p.ts))
                    checked = checked.filter(m => m !== p.ts)
                else
                    checked.push(p.ts);
                setCheckedMoves(checked);
                payment.amount = 0;
                for (let move of moves)
                    if (checked.includes(move.key)) {
                        concept.add(move.Concepto);
                        payment.amount += Number(move.Monto);
                    }
                payment.concept = [...concept].join(', ');
                break;
            case 'amount':
                let remaining = p.amount;
                checked = [];
                for (let move of moves) {
                    if (['vencido', 'debito'].includes(move.status) && remaining >= move.Monto) {
                        checked.push(move.key);
                        remaining -= move.Monto;
                    }
                }
                setCheckedMoves(checked);
                break;
            case 'total':
                payment.discount = ((1 - (Number(payment.total) / Number(payment.amount))) * 100).toFixed(2);
                break;
            default:
                break;
        }

        if (pKey !== 'total')
            payment.total = (Number(payment.amount) * (1 - ((payment.discount || 0) / 100))).toFixed(0);

        for (let move of moves.filter(m => checked.includes(m.key))) {
            detail.push(`${move.Concepto} (${move.Vencimiento}) ${payment.discount > 0 ? ('(-' + payment.discount + '%) ') : ''}$${Math.round(move.Monto * (1 - ((payment.discount || 0) / 100)))}`);
            member.push(move.socio);
        }
        payment.detail = detail.join("\n");
        payment.member = [...new Set(member)].toSorted().join(',');
        payment.disabled = !payment.concept || !payment.amount || !payment.method;
        setNewPayment(payment);
    }

    const newPaymentUpload = () => {
        let payment = { ...newPayment },
            uploadsArray = {},
            checked = [...checkedMoves],
            data = {
                Concepto: payment.concept,
                Descuento: payment.discount,
                DetEstado: payment.detail,
                Estado: 'Pago',
                Fecha: dateString().substring(0, 10),
                Medio: payment.method,
                Monto: Number(payment.total),
                Pago: Number(payment.total),
                Timestamp: new Date(),
                UserId: User.uid,
                Usuario: User.nombre,
                socio: payment.member,
                montoOrig: payment.amount,
                recibo: lastReceitpNumber + 1,
                tipo: 'pago',
            };

        console.log(data, payment)
        Object.assign(uploadsArray, Obj2StrArr(data, `/movements/${data.socio}/${data.Fecha}/${dateString().replaceAll('.', ',')}`) || {});

        for (let move of moves.filter(m => checked.includes(m.key))) {
            let paymentData = {
                Estado: 'Pagado',
                Monto: Math.round(move.Monto * (1 - ((payment.discount || 0) / 100))),
                DetEstado: `Pago registrado el ${new Date().toLocaleString().replaceAll(',', '')}${payment.discount > 0 ? (' con descuento ' + payment.discount + '%') : ''}, monto orig $${move.Monto}`,
            };
            Object.assign(uploadsArray, Obj2StrArr(paymentData, `/movements/${move.socio}/${move.Vencimiento}/${move.key}`) || {});
        }

        if (Object.keys(uploadsArray).length > 0) {
            DbUpload(uploadsArray).then(r => r && offlineMovementsUpdate());
            setNewPayment({ disabled: false, show: false, total: 0, discount: 0, concept: '', amount: '' });
            setReceiptRendering({ ...data, render: true });
            setCheckedMoves([]);
        }
    };

    const removeCheckedDebits = () => {
        if (!removeDebitList.length) return;
        let removeList = [],
            text = `¿Confirma anular ${removeDebitList.length > 1 ? ('los ' + removeDebitList.length) : 'el'} débito${removeDebitList.length > 1 ? 's' : ''} seleccionado${removeDebitList.length > 1 ? 's' : ''}?${"\n"}`;
        text += `Socio ${MemberData.apellido} ${MemberData.nombre} - DNI ${MemberData.documentonumero}${"\n"}`;
        for (let v in MovementsData)
            for (let k in MovementsData[v])
                if (removeDebitList.includes(k))
                    removeList.push({ k: k, v: v, m: MovementsData[v][k].socio })
        const sortableMove = (m) => MovementsData[m.v][m.k].Concepto + MovementsData[m.v][m.k].Vencimiento;
        removeList.sort((a, b) => sortableMove(a).localeCompare(sortableMove(b)));
        for (let m of removeList)
            text += `${"\n"}${MovementsData[m.v][m.k].Vencimiento} - ${MovementsData[m.v][m.k].Concepto}  $${MovementsData[m.v][m.k].Monto} `;
        if (window.confirm(text)) {
            let uploadsArray = {};
            for (let m of removeList)
                Object.assign(uploadsArray, cancelDebit(m.m, m.v, m.k))
            DbUpload(uploadsArray).then(r => r && offlineMovementsUpdate());
        }
        setRemoveDebitList([]);
    }

    return (
        <Box sx={{
            height: '100%',
            overflow: 'auto',
            py: 2,
            '& .MuiFormLabel-root[data-shrink="false"]': {
                top: '-.5em'
            }
        }}>
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 2,
                height: '100%',
            }}>
                {!minimal && (<Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Box
                        sx={{ fontSize: 18, fontWeight: 'bold' }}
                    >
                        Movimientos en la Cuenta
                    </Box>

                </Box>)}
                <Box
                    sx={{
                        flex: '1 1 100%',
                        overflow: 'auto',
                    }}
                >
                    <Table
                        stickyHeader
                        size="small"
                        sx={{
                            width: 'auto',

                            '& .MuiTableCell-root': {
                                borderBottom: "none",
                                px: 1,
                                py: 0.5,
                            },
                            '& .MuiTableCell-root:first-of-type': {
                                textAlign: 'end'
                            },
                            '& .group-header': {
                                cursor: 'pointer'
                            },
                            '& .group-header .MuiTableCell-root:first-of-type': {
                                fontWeight: 'bold',
                                textAlign: 'start'
                            },
                            '& .group-header .MuiTableCell-root:last-of-type': {
                                fontWeight: 'bold',
                                textAlign: 'end',
                            },
                            '& input': {
                                py: 0,
                                px: 1,
                                fontSize: 14,
                            },

                        }}
                    >
                        <TableHead>
                            <TableRow>
                                {dataTable.map(field =>
                                    <TableCell key={`${field.header}-tableheader`}>{field.header}</TableCell>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {moves.filter(m => ['vencido', 'debito'].includes(m.status)).map(moveRow)}
                            {!minimal && !specialDebit.show && !newPayment.show && removeDebitList.length === 0 &&
                                <TableRow
                                    sx={{
                                        '& td': {
                                            textAlign: 'center !important',
                                            position: 'sticky',
                                            bottom: 0,
                                            zIndex: 2,
                                            backgroundColor: '#fff',
                                        }
                                    }}
                                >
                                    <TableCell
                                        colSpan={3}
                                    >
                                        <Button
                                            type="text"
                                            variant="text"
                                            color="black"
                                            onClick={() => specialDebitSet({ show: true })}
                                            sx={{
                                                fontSize: 10,
                                                fontStyle: 'italic',
                                                textTransform: 'none',
                                            }}
                                        >
                                            Nuevo Debito Especial
                                        </Button>
                                    </TableCell>
                                    <TableCell
                                        colSpan={3}
                                    >
                                        <Button
                                            type="text"
                                            variant="text"
                                            color="black"
                                            onClick={() => newPaymentSet({ show: true })}
                                            sx={{
                                                fontSize: 10,
                                                fontStyle: 'italic',
                                                textTransform: 'none',
                                            }}
                                        >
                                            Nuevo Pago
                                        </Button>
                                    </TableCell>
                                </TableRow>}
                            {newPayment.show &&
                                <TableRow
                                    sx={{
                                        '& td': {
                                            position: 'sticky',
                                            bottom: 0,
                                            zIndex: 2,
                                            backgroundColor: '#fff',
                                        }
                                    }}
                                >
                                    <TableCell
                                        colSpan={2}
                                    >
                                        <TextField
                                            id='newPaymentConcept'
                                            variant="standard"

                                            value={newPayment.concept || ''}
                                            onChange={(e) => newPaymentSet({ concept: e.target.value })}
                                            label='Concepto'
                                            type='text'
                                        />
                                    </TableCell>

                                    <TableCell
                                        colSpan={2}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                            }}>

                                            <TextField
                                                id='newPaymentAmount'
                                                variant="standard"
                                                value={newPayment.amount || 0}
                                                onChange={(e) => newPaymentSet({ amount: e.target.value || 1 })}
                                                type='number'
                                                label='Monto $'

                                                sx={{
                                                    width: '5em',
                                                    '& input': { appearance: 'none', textAlign: 'center' },
                                                    '& input::-webkit-outer-spin-button': {
                                                        appearance: 'none',
                                                        margin: 0,
                                                    },
                                                    '& input::-webkit-inner-spin-button': {
                                                        appearance: 'none',
                                                        margin: 0,
                                                    },
                                                }}
                                            />


                                            <TextField
                                                id='newPaymentDiscount'
                                                variant="standard"
                                                value={newPayment.discount || 0}
                                                onChange={(e) => newPaymentSet({ discount: e.target.value || 1 })}
                                                type='number'
                                                label='Dto %'
                                                sx={{
                                                    width: '5em',
                                                    '& input': { appearance: 'none', textAlign: 'center' },
                                                    '& input::-webkit-outer-spin-button': {
                                                        appearance: 'none',
                                                        margin: 0,
                                                    },
                                                    '& input::-webkit-inner-spin-button': {
                                                        appearance: 'none',
                                                        margin: 0,
                                                    },
                                                }}
                                            />

                                            <TextField
                                                id='newPaymentTotal'
                                                variant="standard"
                                                value={newPayment.total || 0}
                                                onChange={(e) => newPaymentSet({ total: e.target.value || 1 })}
                                                type='number'
                                                label='Pago $'
                                                sx={{
                                                    width: '5em',
                                                    '& input': { appearance: 'none', textAlign: 'center' },
                                                    '& input::-webkit-outer-spin-button': {
                                                        appearance: 'none',
                                                        margin: 0,
                                                    },
                                                    '& input::-webkit-inner-spin-button': {
                                                        appearance: 'none',
                                                        margin: 0,
                                                    },
                                                }}
                                            />
                                        </Box>

                                    </TableCell>

                                    <TableCell>
                                        <FormControl variant="standard" fullWidth>
                                            <InputLabel id="newPaymentMethod-label">Medio</InputLabel>
                                            <Select
                                                labelId="newPaymentMethod-label"
                                                id="newPaymentMethod"
                                                value={newPayment.method || ''}
                                                onChange={(e) => newPaymentSet({ method: e.target.value })}
                                                label="Medio"
                                                sx={{ fontSize: '1em', '& .MuiSelect-select': { py: 0 } }}
                                            >
                                                {Means && Means.map((mean) => {
                                                    return mean ? (
                                                        <MenuItem key={mean} value={mean} sx={{ fontSize: '.85em' }}>{mean}</MenuItem>
                                                    ) : ''
                                                })}
                                            </Select>
                                        </FormControl>
                                    </TableCell>

                                    <TableCell>
                                        <IconButton
                                            aria-label="save"
                                            disabled={newPayment.disabled}
                                            onClick={newPaymentUpload}
                                        >
                                            <CloudUploadIcon color={newPayment.disabled ? 'disabled' : 'success'} />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            }
                            {specialDebit.show &&
                                <TableRow
                                    sx={{
                                        '& td': {
                                            position: 'sticky',
                                            bottom: 0,
                                            zIndex: 2,
                                            backgroundColor: '#fff',
                                        }
                                    }}
                                >
                                    <TableCell
                                        colSpan={2}
                                    >
                                        <TextField
                                            id='specialDebitConcept'
                                            variant="standard"

                                            value={specialDebit.concept || ''}
                                            onChange={(e) => specialDebitSet({ concept: e.target.value })}
                                            label='Concepto'
                                            type='text'
                                        />
                                    </TableCell>
                                    <TableCell
                                        colSpan={2}
                                    >
                                        <TextField
                                            id='specialDebitAmount'
                                            variant="standard"
                                            value={specialDebit.amount || ''}
                                            onChange={(e) => specialDebitSet({ amount: e.target.value })}
                                            label='Monto $'
                                            type='text'
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            id='specialDebitCount'
                                            variant="standard"
                                            label='Cuotas'
                                            value={specialDebit.count || 1}
                                            onChange={(e) => specialDebitSet({ count: e.target.value || 1 })}
                                            type='number'
                                            sx={{
                                                width: '5em',
                                                '& input': { appearance: 'none', textAlign: 'center' },
                                                '& input::-webkit-outer-spin-button': {
                                                    appearance: 'none',
                                                    margin: 0,
                                                },
                                                '& input::-webkit-inner-spin-button': {
                                                    appearance: 'none',
                                                    margin: 0,
                                                },
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <IconButton
                                            aria-label="save"
                                            disabled={specialDebit.disabled}
                                            onClick={specialDebitUpload}
                                        >
                                            <CloudUploadIcon color={specialDebit.disabled ? 'disabled' : 'success'} />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            }
                            {removeDebitList.length > 0 &&
                                <TableRow
                                    sx={{
                                        '& td': {
                                            textAlign: 'center !important',
                                            position: 'sticky',
                                            bottom: 0,
                                            zIndex: 2,
                                            backgroundColor: '#fff',
                                        }
                                    }}
                                >
                                    <TableCell
                                        colSpan={4}
                                    >
                                        <Button
                                            type="text"
                                            variant="text"
                                            color="black"
                                            onClick={removeCheckedDebits}
                                            sx={{
                                                fontSize: 10,
                                                fontStyle: 'italic',
                                                textTransform: 'none',
                                            }}
                                        >
                                            Anular los {removeDebitList.length} debitos seleccionados
                                        </Button>
                                    </TableCell>
                                    <TableCell
                                        colSpan={2}
                                    >
                                        <Button
                                            type="text"
                                            variant="text"
                                            color="black"
                                            onClick={() => setRemoveDebitList([])}
                                            sx={{
                                                fontSize: 10,
                                                fontStyle: 'italic',
                                                textTransform: 'none',
                                            }}
                                        >
                                            Limpiar selección
                                        </Button>
                                    </TableCell>
                                </TableRow>}
                            {!minimal && (<TableRow>
                                <TableCell
                                    colSpan={6}
                                    sx={{ textAlign: 'center !important' }}
                                >
                                    <Button
                                        type="text"
                                        variant="text"
                                        color="black"
                                        onClick={() => setShowHistory(!showHistory)}
                                        sx={{
                                            fontSize: 10,
                                            textTransform: 'none',
                                            mt: 1,
                                        }}
                                    >
                                        {showHistory ? 'Ocultar' : 'Ver'} Movimientos Históricos
                                    </Button>
                                </TableCell>
                            </TableRow>)}
                            {showHistory &&
                                moves.toReversed().filter(m => !['vencido', 'debito'].includes(m.status)).map(moveRow)
                            }
                        </TableBody>
                    </Table>
                    {!minimal && receiptRendering.render &&
                        <Box
                            sx={{
                                width: '0px',
                                height: '0px',
                                overflow: 'hidden',
                            }}
                        >
                            <Receipt
                                activeReceipt={receiptRendering}
                                setReceiptRendering={setReceiptRendering}
                                MemberData={MemberData}
                                FamilyGroupData={FamilyGroupData}
                            />
                        </Box>}
                </Box>
            </Box >
        </Box >
    )
}

export default MemberMovements;
